<app-panel-body>
  <div class="flex min-h-0 flex-1 flex-col">
    <div class="min-h-0 flex-1 overflow-y-auto">
      <app-content-container>
      <div class="location-swap-cards">
        @for (trip of activeTrips(); track trip.id) {
        <div class="location-card" [class.active]="trip.id === currentTrip()?.id"
          [style.background-image]="'url(assets/images/locations/' + trip.locId + '.jpg)' + ', url(assets/images/costa_rica_background.png)' " (click)="setCurrentTrip(trip.id)">
          <div class="location-card-overlay"></div>
          <div class="location-card-icon">
            <!-- <img [src]="trip.flagImage" [alt]="trip.locationName" class="country-map-icon"> -->
          </div>
          <div class="location-card-content">
            <h3>{{ trip.locationName }}</h3>
            <p>{{ trip.tripDate | date:'MM/dd/yyyy' }}</p>
          </div>
          <div class="location-card-badge">{{ trip.daysAway }} Days Away</div>
        </div>
        }

      </div>

      <div>
        <h2>Past Trips</h2>
        <div class="location-swap-cards">
          @for (trip of pastTrips(); track trip.id) {
          <div class="location-card" [class.active]="trip.id === currentTrip()?.id"
            [style.background-image]="'url(assets/images/locations/' + trip.locId + '.jpg)' + ', url(assets/images/costa_rica_background.png)' " (click)="setCurrentTrip(trip.id)">
            <div class="location-card-overlay"></div>
            <div class="location-card-icon">
              <!-- <img [src]="trip.flagImage" [alt]="trip.locationName" class="country-map-icon"> -->
            </div>
            <div class="location-card-content">
              <h3>{{ trip.locationName }}</h3>
              <p>{{ trip.tripDate | date:'MM/dd/yyyy' }}</p>
            </div>

          </div>
          }
        </div>
      </div>
      </app-content-container>
    </div>
  </div>
</app-panel-body>
